import { render, staticRenderFns } from "./RenovarDocumento.vue?vue&type=template&id=23c9357a"
import script from "./RenovarDocumento.vue?vue&type=script&lang=js"
export * from "./RenovarDocumento.vue?vue&type=script&lang=js"
import style0 from "./RenovarDocumento.vue?vue&type=style&index=0&id=23c9357a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports